import { render } from "./NewPassword.vue?vue&type=template&id=66a66b10"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__